const FluidGallery = (config) => {

    const { 
        includeTitle, 
        includeBadges, 
        includePrice, 
        include3PVariantPicker,
        appendNavigator,
        navigatorThreshold
    } = config;

    const BLOCK_TITLE_SELECTOR = '.block-title';
    const BLOCK_PRICE_SELECTOR = '.block-price';
    const BLOCK_BADGES_SELECTOR = '.product-badges';
    const BLOCK_3P_SELECTOR = '.webyzeProductColorsLabel'

    let selectors = [];
    let observables = [];
    let heights = [];

    const mainElement = document.querySelector('.product-main-element');
    const headerElement = document.querySelector('.header-outer');
    const mainProductInfoElement = mainElement.querySelector('.main-product-info')
    let navigatorButton = null;

    if (!mainElement) return;

    const computeElementHeight = (el) => {
        if (!el) return 0;
        const rect = el.getBoundingClientRect();
        const style = getComputedStyle(el);
        const marginTop = parseFloat(style.marginTop);
        const marginBottom = parseFloat(style.marginBottom);
        return rect.height + marginTop + marginBottom;
    }

    const computeOutstandingHeights = () => {
        // paddingTop
        const mainProductInfoComputedStyle = getComputedStyle(mainProductInfoElement);
        if (mainProductInfoComputedStyle) heights = [...heights.filter(h => h.selector !== 'main-product-info-padding'), { selector: 'main-product-info-padding', height: parseInt(mainProductInfoComputedStyle.paddingTop) }]

        // header
        const headerHeight = headerElement.getBoundingClientRect().height;
        heights = [...heights.filter(h => h.selector !== 'header-height'), { selector: 'header-height', height: headerHeight }]

        if (!navigatorButton) return;
        const navigatorButtonHeight = navigatorButton.getBoundingClientRect().height;
        heights = [...heights.filter(h => h.selector !== 'navigator-button'), { selector: 'navigator-button', height: navigatorButtonHeight }]
    }

    const adjustHeight = () => {
        computeSelectorsHeights()
        computeOutstandingHeights()
        let totalHeight = heights.reduce((total, h) => total + h.height, 0) + 60;
        // mainElement.querySelector('.gallery-wrap').style.setProperty('--mobile-product-visibile-height', `${totalHeight}px`)
    }

    const computeSelectorsHeights = () => {
        selectors.forEach(selector => {
            const el = mainElement.querySelector(selector);
            const height = computeElementHeight(el);
            heights = [...heights.filter(h => h.selector !== selector), { selector, height }]
        })
    }

    /** This function calculates de height of the swatches that are loaded async */
    const initObservers = () => {
        if (observables.length == 0) return;
        const observer = new MutationObserver(mutations => {
            for (const mutation of mutations) {
                if (mutation.type === 'childList') {
                    let el = mutation.target;
                    let whichObservable = ''
                    const includesObservable = observables.reduce((includes, observable) => {
                        let elObservable = mutation.target.querySelector(observable);
                        if (elObservable) whichObservable = observable;
                        return includes && !!elObservable; 
                    }, true)
                    if (includesObservable) {
                        const height = computeElementHeight(mainElement.querySelector(whichObservable));
                        heights = [...heights.filter(h => h.selector !== whichObservable), { selector: whichObservable, height }]
                        adjustHeight()
                    }
                }
            }
        });
        observer.observe(mainElement, {
            childList: true,
            subtree: true,
        });
    } 

    const initNavigator = () => {
        const navigatorTemplate = document.createElement('template');
        navigatorTemplate.innerHTML = `<div class="fluid-navigator large--hide medium--hide" aria-hidden="true">
            <button tabindex="0">
                <svg aria-hidden="true" tabindex="-1" role="icon" class="icon icon-chevron-up" viewBox="0 0 32 32">
                    <path class="stroke" d="M5,22,16,10,27,22"/>
                </svg>
            </button>
        </div>`;
        navigatorButton = navigatorTemplate.content.firstElementChild;
        mainElement.append(navigatorButton);

        navigatorButton.addEventListener('click', event => {
            event.preventDefault()
            navigatorAction()
        });
        navigatorButton.addEventListener('click', event => {
            if (event.keyCode==13) {
                navigatorAction();
            }
        });
        checkScoll()
    }

    const navigatorAction = () => {
        if (!$s) return;
        if (mainElement.classList.contains('scrolled')) {
            window.scrollTo({ top: 0, behavior: 'smooth' })
        } else {
            $s.scrollToElement(mainProductInfoElement)
        }
    }

    const initScroll = () => {
        window.addEventListener('scroll', checkScoll)
    }

    const checkScoll = () => {
        if (window.scrollY > navigatorThreshold) {
            mainElement.classList.add('scrolled')
        } else  {
            mainElement.classList.remove('scrolled')
        }
    }

    const init = () => {

        // Adding the corresponding selectors to calculate height of visible form
        if (includeTitle) 
            selectors = [...selectors, BLOCK_TITLE_SELECTOR];
        if (includePrice) 
            selectors = [...selectors, BLOCK_PRICE_SELECTOR];
        if (includeBadges) 
            selectors = [...selectors, BLOCK_BADGES_SELECTOR];
        if (include3PVariantPicker) 
            observables = [...observables, BLOCK_3P_SELECTOR];
        if (appendNavigator) {
            initNavigator()
            initScroll()
        }

        mainElement.classList.add('vertical-fluid')

        initObservers()
        adjustHeight()
        window.addEventListener('resize', () => adjustHeight())
    }

    return { init }
}